import { render, staticRenderFns } from "./EditMerchant.vue?vue&type=template&id=cd224e48"
import script from "./EditMerchant.vue?vue&type=script&lang=js"
export * from "./EditMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports